import React from "react";
import Nav from "../layout/nav/desktopNav";
import MobileNav from "../layout/nav/mobileNav";
import Footer from "../components/footer/Footer.js";
import Conditions from "../components/Voorwaarden/conditions.js";
import Header from "../components/page-title/header.js";

function ConditionsPage() {
  return (
    <div>
      <Nav />
      <MobileNav />

      <Header
        height={30}
        heightState={true}
        title="Algemene Voorwaarden"
        text="22/10/2023"
      />
      <Conditions />
      <Footer />
    </div>
  );
}

export default ConditionsPage;
